import { SelectOption } from '@/components/form-builder/form-builder.types';
import { AttachedFormDto, DynamicFieldDto } from '@/types';
import { createStore, withProps } from '@ngneat/elf';

export interface DacTransactionalFormAssignmentStateProps {
  dto: AttachedFormDto;
  initialDto?: AttachedFormDto;
  fields: DynamicFieldDto[];
  formSelected?: SelectOption;
  folderTypeSelected?: SelectOption;
  errors: Record<string, any>;
}

export const dacTransactionalFormAssignmentInitialState: DacTransactionalFormAssignmentStateProps = {
  dto: {
    dacId: undefined,
    dacVer: undefined,
    dynaFormId: undefined,
    dynaFormVer: undefined,
    dynaFormFieldsId: [],
    display: true,
  },
  initialDto: undefined,
  fields: [],
  formSelected: { name: '', code: undefined },
  folderTypeSelected: { name: '', code: undefined },
  errors: {},
};

export const dacTransactionalFormAssignmentStore = createStore(
  { name: 'dac-transactional-form-assignment-state' },
  withProps<DacTransactionalFormAssignmentStateProps>({ ...dacTransactionalFormAssignmentInitialState })
);

export const dacTransactionalFormAssignmentStoreFactory = (id: string) => {
  return createStore(
    { name: `dac-transactional-form-assignment-state-${id}` },
    withProps<DacTransactionalFormAssignmentStateProps>(structuredClone(dacTransactionalFormAssignmentInitialState))
  );
};
